import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "../../../components/ui/Button";
import { RoomListItem } from "../../../components/ui/RoomListItem";
import type { SearchRoomItem } from "../hooks/useSearchRoomsQuery";
import { getRoomName } from "../../../domains/room/hooks/useRoomName";
import { useActiveLang } from "../../../domains/app/hooks/useActiveLang";

function getInitials(name: string): string {
  const trimmed = name.trim();
  if (trimmed.length === 0) return "?";
  const words = trimmed.split(/\s+/);
  if (words.length === 1) return trimmed.slice(0, 2).toUpperCase();
  const first = words[0];
  const second = words[1];
  if (first === undefined || second === undefined) return "?";
  return `${first.charAt(0)}${second.charAt(0)}`.toUpperCase();
}

export function SearchTopRoomCard({
  room,
  onVisit,
}: {
  room: SearchRoomItem;
  onVisit: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const { activeLang } = useActiveLang();
  const history = useHistory();
  const roomName = getRoomName(room, activeLang);
  const orgName =
    room.organisationModel === null ? null : room.organisationModel.name;

  return (
    <RoomListItem
      initials={getInitials(roomName)}
      avatarSrc={
        room.icoModel === null
          ? undefined
          : room.icoModel.sizes !== null
            ? room.icoModel.sizes.icon.file
            : room.icoModel.url
      }
      title={roomName}
      subtitle={
        orgName === null ? undefined : t("by {{name}}", { name: orgName })
      }
      action={
        <Button
          size="sm"
          variant="secondary"
          onClick={() => {
            onVisit();
            history.push(`/room/discovery/${room.id}`);
          }}
        >
          {t("Visit room")}
        </Button>
      }
    />
  );
}
